import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import ApiService from "../services/ApiService";
import classnames from 'classnames'
import { format } from "date-fns";
import { connect } from "react-redux";
import { useQuery } from "@tanstack/react-query";

const BrandSources = ({ date, tenant }) => {
  const [activeTab, setActiveTab] = useState(1);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);

  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }
  const {
    data: graphs,
    isLoading,
    isRefetching,
    isSuccess,
  } = useQuery({
    queryKey: ["brandSources", tenant.id, startDate, endDate],
    queryFn: () => ApiService.getBrandSources(since, until),
    select: (data) => data.data.graphs,
    enabled,
    placeholderData: { data: { graphs: [] } },
  });

  const chartOptions = (graph) => {
    return {
      credits: { enabled: false },
      chart: {
        type: "column",
        backgroundColor: 'transparent',
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: graph.data.yTitle,
        },
        labels: {
          style: {
            color: 'var(--text-primary)'
          }
       }
      },
      xAxis: {
        categories: graph.data.labels,
        labels: {
          rotation: -45,
          style: {
            color: 'var(--text-primary)'
         }
        },
        title: {
          text: graph.data.xTitle,
        },
      },
      series: graph.data.series,
      plotOptions: {
        column: {
          stacking: "normal",
          borderColor: null,
        },
      },
    };
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const renderTab = (graph, index) => {
    return (
      <NavItem key={index}>
        <NavLink
          href="#"
          className={classnames({
            active: activeTab === index,
          })}
          onClick={() => {
            toggleTab(index);
          }}
        >
          {graph.source}
        </NavLink>
      </NavItem>
    );
  };

  const renderSource = (graph, index) => {
    return (
      <TabPane tabId={index} className="p-3" key={index}>
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions(graph)}
        />
      </TabPane>
    );
  };

  return (
    <>
      {(isLoading || isRefetching) && <Spinner color="primary" />}
      {isSuccess && (
        <>
          <Nav pills className="navtab-bg my-4 center-pills">
            {graphs.map((graph, index) => renderTab(graph, index))}
          </Nav>
          <TabContent activeTab={activeTab}>
            {graphs.map((graph, index) => renderSource(graph, index))}
          </TabContent>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  date: state.date,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(BrandSources);
